"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Solvex.Hr.Ehiring.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkplaceApi = exports.WorkplaceApiFactory = exports.WorkplaceApiFp = exports.WorkplaceApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.OrganizationalUnitApi = exports.OrganizationalUnitApiFactory = exports.OrganizationalUnitApiFp = exports.OrganizationalUnitApiAxiosParamCreator = exports.JobOpeningSubmissionApi = exports.JobOpeningSubmissionApiFactory = exports.JobOpeningSubmissionApiFp = exports.JobOpeningSubmissionApiAxiosParamCreator = exports.JobOpeningApi = exports.JobOpeningApiFactory = exports.JobOpeningApiFp = exports.JobOpeningApiAxiosParamCreator = exports.JobApplicationKeyCommentApi = exports.JobApplicationKeyCommentApiFactory = exports.JobApplicationKeyCommentApiFp = exports.JobApplicationKeyCommentApiAxiosParamCreator = exports.JobApplicationFileApi = exports.JobApplicationFileApiFactory = exports.JobApplicationFileApiFp = exports.JobApplicationFileApiAxiosParamCreator = exports.JobApplicationCommentApi = exports.JobApplicationCommentApiFactory = exports.JobApplicationCommentApiFp = exports.JobApplicationCommentApiAxiosParamCreator = exports.JobApplicationApi = exports.JobApplicationApiFactory = exports.JobApplicationApiFp = exports.JobApplicationApiAxiosParamCreator = exports.JobActivityApi = exports.JobActivityApiFactory = exports.JobActivityApiFp = exports.JobActivityApiAxiosParamCreator = exports.EmailTemplateApi = exports.EmailTemplateApiFactory = exports.EmailTemplateApiFp = exports.EmailTemplateApiAxiosParamCreator = exports.EmailApi = exports.EmailApiFactory = exports.EmailApiFp = exports.EmailApiAxiosParamCreator = exports.CandidatePoolSubmissionApi = exports.CandidatePoolSubmissionApiFactory = exports.CandidatePoolSubmissionApiFp = exports.CandidatePoolSubmissionApiAxiosParamCreator = exports.CandidatePoolApi = exports.CandidatePoolApiFactory = exports.CandidatePoolApiFp = exports.CandidatePoolApiAxiosParamCreator = exports.BranchOfficeApi = exports.BranchOfficeApiFactory = exports.BranchOfficeApiFp = exports.BranchOfficeApiAxiosParamCreator = exports.AreaApi = exports.AreaApiFactory = exports.AreaApiFp = exports.AreaApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * AreaApi - axios parameter creator
 * @export
 */
exports.AreaApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areaGetAll: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/Area";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AreaApi - functional programming interface
 * @export
 */
exports.AreaApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AreaApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areaGetAll: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.areaGetAll(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AreaApi - factory interface
 * @export
 */
exports.AreaApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AreaApiFp(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areaGetAll: function (xTenantID, options) {
            return localVarFp.areaGetAll(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AreaApi - object-oriented interface
 * @export
 * @class AreaApi
 * @extends {BaseAPI}
 */
var AreaApi = /** @class */ (function (_super) {
    __extends(AreaApi, _super);
    function AreaApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AreaApi
     */
    AreaApi.prototype.areaGetAll = function (xTenantID, options) {
        var _this = this;
        return exports.AreaApiFp(this.configuration).areaGetAll(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AreaApi;
}(base_1.BaseAPI));
exports.AreaApi = AreaApi;
/**
 * BranchOfficeApi - axios parameter creator
 * @export
 */
exports.BranchOfficeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        branchOfficeGetAll: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/BranchOffice";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * BranchOfficeApi - functional programming interface
 * @export
 */
exports.BranchOfficeApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.BranchOfficeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        branchOfficeGetAll: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.branchOfficeGetAll(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * BranchOfficeApi - factory interface
 * @export
 */
exports.BranchOfficeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.BranchOfficeApiFp(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        branchOfficeGetAll: function (xTenantID, options) {
            return localVarFp.branchOfficeGetAll(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * BranchOfficeApi - object-oriented interface
 * @export
 * @class BranchOfficeApi
 * @extends {BaseAPI}
 */
var BranchOfficeApi = /** @class */ (function (_super) {
    __extends(BranchOfficeApi, _super);
    function BranchOfficeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BranchOfficeApi
     */
    BranchOfficeApi.prototype.branchOfficeGetAll = function (xTenantID, options) {
        var _this = this;
        return exports.BranchOfficeApiFp(this.configuration).branchOfficeGetAll(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BranchOfficeApi;
}(base_1.BaseAPI));
exports.BranchOfficeApi = BranchOfficeApi;
/**
 * CandidatePoolApi - axios parameter creator
 * @export
 */
exports.CandidatePoolApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolConsentReceive: function (poolId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'poolId' is not null or undefined
                    common_1.assertParamExists('candidatePoolConsentReceive', 'poolId', poolId);
                    localVarPath = "/CandidatePool/{poolId}/Consent"
                        .replace("{" + "poolId" + "}", encodeURIComponent(String(poolId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xTenantID !== undefined && xTenantID !== null) {
                        localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolDelete: function (poolId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'poolId' is not null or undefined
                            common_1.assertParamExists('candidatePoolDelete', 'poolId', poolId);
                            localVarPath = "/CandidatePool/{poolId}"
                                .replace("{" + "poolId" + "}", encodeURIComponent(String(poolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateCandidatePoolEntry} [createCandidatePoolEntry]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAdd: function (createCandidatePoolEntry, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/CandidatePool/Entry";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCandidatePoolEntry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAddFromApplication: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromApplication', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromApplication', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Entry"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {string} areaOfInterest
         * @param {string} [workplaceName]
         * @param {string} [comment]
         * @param {string} [branchOffice]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAddFromForm: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'firstName' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'firstName', firstName);
                            // verify required parameter 'lastName' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'lastName', lastName);
                            // verify required parameter 'email' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'email', email);
                            // verify required parameter 'phoneNumber' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'phoneNumber', phoneNumber);
                            // verify required parameter 'workExperience' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'workExperience', workExperience);
                            // verify required parameter 'educationGrade' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'educationGrade', educationGrade);
                            // verify required parameter 'education' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'education', education);
                            // verify required parameter 'areaOfInterest' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryAddFromForm', 'areaOfInterest', areaOfInterest);
                            localVarPath = "/CandidatePool/Entry/Form";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            if (firstName !== undefined) {
                                localVarFormParams.append('FirstName', firstName);
                            }
                            if (lastName !== undefined) {
                                localVarFormParams.append('LastName', lastName);
                            }
                            if (email !== undefined) {
                                localVarFormParams.append('Email', email);
                            }
                            if (phoneNumber !== undefined) {
                                localVarFormParams.append('PhoneNumber', phoneNumber);
                            }
                            if (workExperience !== undefined) {
                                localVarFormParams.append('WorkExperience', workExperience);
                            }
                            if (educationGrade !== undefined) {
                                localVarFormParams.append('EducationGrade', educationGrade);
                            }
                            if (education !== undefined) {
                                localVarFormParams.append('Education', education);
                            }
                            if (areaOfInterest !== undefined) {
                                localVarFormParams.append('AreaOfInterest', areaOfInterest);
                            }
                            if (workplaceName !== undefined) {
                                localVarFormParams.append('WorkplaceName', workplaceName);
                            }
                            if (comment !== undefined) {
                                localVarFormParams.append('Comment', comment);
                            }
                            if (branchOffice !== undefined) {
                                localVarFormParams.append('BranchOffice', branchOffice);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryGetAll: function (poolId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'poolId' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryGetAll', 'poolId', poolId);
                            localVarPath = "/CandidatePool/{poolId}/Entry"
                                .replace("{" + "poolId" + "}", encodeURIComponent(String(poolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {number} entryId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryGetById: function (poolId, entryId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'poolId' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryGetById', 'poolId', poolId);
                            // verify required parameter 'entryId' is not null or undefined
                            common_1.assertParamExists('candidatePoolEntryGetById', 'entryId', entryId);
                            localVarPath = "/CandidatePool/{poolId}/Entry/{entryId}"
                                .replace("{" + "poolId" + "}", encodeURIComponent(String(poolId)))
                                .replace("{" + "entryId" + "}", encodeURIComponent(String(entryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolGetById: function (poolId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'poolId' is not null or undefined
                            common_1.assertParamExists('candidatePoolGetById', 'poolId', poolId);
                            localVarPath = "/CandidatePool/{poolId}"
                                .replace("{" + "poolId" + "}", encodeURIComponent(String(poolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {LazyLoadCandidatePool} [lazyLoadCandidatePool]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSearch: function (lazyLoadCandidatePool, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/CandidatePool/Search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(lazyLoadCandidatePool, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {CreateCandidatePool} [createCandidatePool]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolUpdate: function (poolId, createCandidatePool, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'poolId' is not null or undefined
                            common_1.assertParamExists('candidatePoolUpdate', 'poolId', poolId);
                            localVarPath = "/CandidatePool/{poolId}"
                                .replace("{" + "poolId" + "}", encodeURIComponent(String(poolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCandidatePool, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolsGetAll: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/CandidatePool";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CandidatePoolApi - functional programming interface
 * @export
 */
exports.CandidatePoolApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.CandidatePoolApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolConsentReceive: function (poolId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolConsentReceive(poolId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolDelete: function (poolId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolDelete(poolId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateCandidatePoolEntry} [createCandidatePoolEntry]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAdd: function (createCandidatePoolEntry, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolEntryAdd(createCandidatePoolEntry, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAddFromApplication: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolEntryAddFromApplication(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {string} areaOfInterest
         * @param {string} [workplaceName]
         * @param {string} [comment]
         * @param {string} [branchOffice]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAddFromForm: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolEntryAddFromForm(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryGetAll: function (poolId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolEntryGetAll(poolId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {number} entryId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryGetById: function (poolId, entryId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolEntryGetById(poolId, entryId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolGetById: function (poolId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolGetById(poolId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {LazyLoadCandidatePool} [lazyLoadCandidatePool]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSearch: function (lazyLoadCandidatePool, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolSearch(lazyLoadCandidatePool, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} poolId
         * @param {CreateCandidatePool} [createCandidatePool]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolUpdate: function (poolId, createCandidatePool, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolUpdate(poolId, createCandidatePool, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolsGetAll: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolsGetAll(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * CandidatePoolApi - factory interface
 * @export
 */
exports.CandidatePoolApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.CandidatePoolApiFp(configuration);
    return {
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolConsentReceive: function (poolId, xTenantID, options) {
            return localVarFp.candidatePoolConsentReceive(poolId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolDelete: function (poolId, xTenantID, options) {
            return localVarFp.candidatePoolDelete(poolId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateCandidatePoolEntry} [createCandidatePoolEntry]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAdd: function (createCandidatePoolEntry, xTenantID, options) {
            return localVarFp.candidatePoolEntryAdd(createCandidatePoolEntry, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAddFromApplication: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.candidatePoolEntryAddFromApplication(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {string} areaOfInterest
         * @param {string} [workplaceName]
         * @param {string} [comment]
         * @param {string} [branchOffice]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryAddFromForm: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
            return localVarFp.candidatePoolEntryAddFromForm(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryGetAll: function (poolId, xTenantID, options) {
            return localVarFp.candidatePoolEntryGetAll(poolId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} poolId
         * @param {number} entryId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolEntryGetById: function (poolId, entryId, xTenantID, options) {
            return localVarFp.candidatePoolEntryGetById(poolId, entryId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} poolId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolGetById: function (poolId, xTenantID, options) {
            return localVarFp.candidatePoolGetById(poolId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LazyLoadCandidatePool} [lazyLoadCandidatePool]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSearch: function (lazyLoadCandidatePool, xTenantID, options) {
            return localVarFp.candidatePoolSearch(lazyLoadCandidatePool, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} poolId
         * @param {CreateCandidatePool} [createCandidatePool]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolUpdate: function (poolId, createCandidatePool, xTenantID, options) {
            return localVarFp.candidatePoolUpdate(poolId, createCandidatePool, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolsGetAll: function (xTenantID, options) {
            return localVarFp.candidatePoolsGetAll(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CandidatePoolApi - object-oriented interface
 * @export
 * @class CandidatePoolApi
 * @extends {BaseAPI}
 */
var CandidatePoolApi = /** @class */ (function (_super) {
    __extends(CandidatePoolApi, _super);
    function CandidatePoolApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} poolId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolConsentReceive = function (poolId, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolConsentReceive(poolId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} poolId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolDelete = function (poolId, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolDelete(poolId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateCandidatePoolEntry} [createCandidatePoolEntry]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolEntryAdd = function (createCandidatePoolEntry, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolEntryAdd(createCandidatePoolEntry, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolEntryAddFromApplication = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolEntryAddFromApplication(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} email
     * @param {string} phoneNumber
     * @param {string} workExperience
     * @param {string} educationGrade
     * @param {string} education
     * @param {string} areaOfInterest
     * @param {string} [workplaceName]
     * @param {string} [comment]
     * @param {string} [branchOffice]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolEntryAddFromForm = function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolEntryAddFromForm(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} poolId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolEntryGetAll = function (poolId, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolEntryGetAll(poolId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} poolId
     * @param {number} entryId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolEntryGetById = function (poolId, entryId, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolEntryGetById(poolId, entryId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} poolId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolGetById = function (poolId, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolGetById(poolId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LazyLoadCandidatePool} [lazyLoadCandidatePool]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolSearch = function (lazyLoadCandidatePool, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolSearch(lazyLoadCandidatePool, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} poolId
     * @param {CreateCandidatePool} [createCandidatePool]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolUpdate = function (poolId, createCandidatePool, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolUpdate(poolId, createCandidatePool, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolApi
     */
    CandidatePoolApi.prototype.candidatePoolsGetAll = function (xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolApiFp(this.configuration).candidatePoolsGetAll(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CandidatePoolApi;
}(base_1.BaseAPI));
exports.CandidatePoolApi = CandidatePoolApi;
/**
 * CandidatePoolSubmissionApi - axios parameter creator
 * @export
 */
exports.CandidatePoolSubmissionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {string} recaptchaEncodedString
         * @param {string} [areaOfInterest]
         * @param {string} [workplaceName]
         * @param {string} [comment]
         * @param {string} [branchOffice]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSubmissionCreate: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firstName' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'firstName', firstName);
                    // verify required parameter 'lastName' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'lastName', lastName);
                    // verify required parameter 'email' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'email', email);
                    // verify required parameter 'phoneNumber' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'phoneNumber', phoneNumber);
                    // verify required parameter 'workExperience' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'workExperience', workExperience);
                    // verify required parameter 'educationGrade' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'educationGrade', educationGrade);
                    // verify required parameter 'education' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'education', education);
                    // verify required parameter 'recaptchaEncodedString' is not null or undefined
                    common_1.assertParamExists('candidatePoolSubmissionCreate', 'recaptchaEncodedString', recaptchaEncodedString);
                    localVarPath = "/CandidatePoolSubmission";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                    if (xTenantID !== undefined && xTenantID !== null) {
                        localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                    }
                    if (firstName !== undefined) {
                        localVarFormParams.append('FirstName', firstName);
                    }
                    if (lastName !== undefined) {
                        localVarFormParams.append('LastName', lastName);
                    }
                    if (email !== undefined) {
                        localVarFormParams.append('Email', email);
                    }
                    if (phoneNumber !== undefined) {
                        localVarFormParams.append('PhoneNumber', phoneNumber);
                    }
                    if (workExperience !== undefined) {
                        localVarFormParams.append('WorkExperience', workExperience);
                    }
                    if (educationGrade !== undefined) {
                        localVarFormParams.append('EducationGrade', educationGrade);
                    }
                    if (education !== undefined) {
                        localVarFormParams.append('Education', education);
                    }
                    if (areaOfInterest !== undefined) {
                        localVarFormParams.append('AreaOfInterest', areaOfInterest);
                    }
                    if (workplaceName !== undefined) {
                        localVarFormParams.append('WorkplaceName', workplaceName);
                    }
                    if (comment !== undefined) {
                        localVarFormParams.append('Comment', comment);
                    }
                    if (branchOffice !== undefined) {
                        localVarFormParams.append('BranchOffice', branchOffice);
                    }
                    if (recaptchaEncodedString !== undefined) {
                        localVarFormParams.append('RecaptchaEncodedString', recaptchaEncodedString);
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSubmissionGet: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/CandidatePoolSubmission";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xTenantID !== undefined && xTenantID !== null) {
                        localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * CandidatePoolSubmissionApi - functional programming interface
 * @export
 */
exports.CandidatePoolSubmissionApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.CandidatePoolSubmissionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {string} recaptchaEncodedString
         * @param {string} [areaOfInterest]
         * @param {string} [workplaceName]
         * @param {string} [comment]
         * @param {string} [branchOffice]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSubmissionCreate: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolSubmissionCreate(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSubmissionGet: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.candidatePoolSubmissionGet(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * CandidatePoolSubmissionApi - factory interface
 * @export
 */
exports.CandidatePoolSubmissionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.CandidatePoolSubmissionApiFp(configuration);
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {string} recaptchaEncodedString
         * @param {string} [areaOfInterest]
         * @param {string} [workplaceName]
         * @param {string} [comment]
         * @param {string} [branchOffice]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSubmissionCreate: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
            return localVarFp.candidatePoolSubmissionCreate(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidatePoolSubmissionGet: function (xTenantID, options) {
            return localVarFp.candidatePoolSubmissionGet(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CandidatePoolSubmissionApi - object-oriented interface
 * @export
 * @class CandidatePoolSubmissionApi
 * @extends {BaseAPI}
 */
var CandidatePoolSubmissionApi = /** @class */ (function (_super) {
    __extends(CandidatePoolSubmissionApi, _super);
    function CandidatePoolSubmissionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} email
     * @param {string} phoneNumber
     * @param {string} workExperience
     * @param {string} educationGrade
     * @param {string} education
     * @param {string} recaptchaEncodedString
     * @param {string} [areaOfInterest]
     * @param {string} [workplaceName]
     * @param {string} [comment]
     * @param {string} [branchOffice]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolSubmissionApi
     */
    CandidatePoolSubmissionApi.prototype.candidatePoolSubmissionCreate = function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolSubmissionApiFp(this.configuration).candidatePoolSubmissionCreate(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, recaptchaEncodedString, areaOfInterest, workplaceName, comment, branchOffice, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatePoolSubmissionApi
     */
    CandidatePoolSubmissionApi.prototype.candidatePoolSubmissionGet = function (xTenantID, options) {
        var _this = this;
        return exports.CandidatePoolSubmissionApiFp(this.configuration).candidatePoolSubmissionGet(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CandidatePoolSubmissionApi;
}(base_1.BaseAPI));
exports.CandidatePoolSubmissionApi = CandidatePoolSubmissionApi;
/**
 * EmailApi - axios parameter creator
 * @export
 */
exports.EmailApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} emailId
         * @param {ChangeEmailStatus} [changeEmailStatus]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailChangeStatusById: function (emailId, changeEmailStatus, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'emailId' is not null or undefined
                            common_1.assertParamExists('emailChangeStatusById', 'emailId', emailId);
                            localVarPath = "/Email/{emailId}"
                                .replace("{" + "emailId" + "}", encodeURIComponent(String(emailId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(changeEmailStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('emailGetByApplicationId', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('emailGetByApplicationId', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Email"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} emailId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailGetById: function (emailId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'emailId' is not null or undefined
                            common_1.assertParamExists('emailGetById', 'emailId', emailId);
                            localVarPath = "/Email/{emailId}"
                                .replace("{" + "emailId" + "}", encodeURIComponent(String(emailId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} subject
         * @param {string} body
         * @param {number} openingId
         * @param {number} applicationId
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailSend: function (subject, body, openingId, applicationId, files, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'subject' is not null or undefined
                            common_1.assertParamExists('emailSend', 'subject', subject);
                            // verify required parameter 'body' is not null or undefined
                            common_1.assertParamExists('emailSend', 'body', body);
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('emailSend', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('emailSend', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Email"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            if (subject !== undefined) {
                                localVarFormParams.append('Subject', subject);
                            }
                            if (body !== undefined) {
                                localVarFormParams.append('Body', body);
                            }
                            if (files) {
                                files.forEach(function (element) {
                                    localVarFormParams.append('files', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EmailApi - functional programming interface
 * @export
 */
exports.EmailApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.EmailApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} emailId
         * @param {ChangeEmailStatus} [changeEmailStatus]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailChangeStatusById: function (emailId, changeEmailStatus, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.emailChangeStatusById(emailId, changeEmailStatus, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.emailGetByApplicationId(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} emailId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailGetById: function (emailId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.emailGetById(emailId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} subject
         * @param {string} body
         * @param {number} openingId
         * @param {number} applicationId
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailSend: function (subject, body, openingId, applicationId, files, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.emailSend(subject, body, openingId, applicationId, files, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * EmailApi - factory interface
 * @export
 */
exports.EmailApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.EmailApiFp(configuration);
    return {
        /**
         *
         * @param {number} emailId
         * @param {ChangeEmailStatus} [changeEmailStatus]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailChangeStatusById: function (emailId, changeEmailStatus, xTenantID, options) {
            return localVarFp.emailChangeStatusById(emailId, changeEmailStatus, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.emailGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} emailId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailGetById: function (emailId, xTenantID, options) {
            return localVarFp.emailGetById(emailId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} subject
         * @param {string} body
         * @param {number} openingId
         * @param {number} applicationId
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailSend: function (subject, body, openingId, applicationId, files, xTenantID, options) {
            return localVarFp.emailSend(subject, body, openingId, applicationId, files, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
var EmailApi = /** @class */ (function (_super) {
    __extends(EmailApi, _super);
    function EmailApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} emailId
     * @param {ChangeEmailStatus} [changeEmailStatus]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    EmailApi.prototype.emailChangeStatusById = function (emailId, changeEmailStatus, xTenantID, options) {
        var _this = this;
        return exports.EmailApiFp(this.configuration).emailChangeStatusById(emailId, changeEmailStatus, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    EmailApi.prototype.emailGetByApplicationId = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.EmailApiFp(this.configuration).emailGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} emailId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    EmailApi.prototype.emailGetById = function (emailId, xTenantID, options) {
        var _this = this;
        return exports.EmailApiFp(this.configuration).emailGetById(emailId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} subject
     * @param {string} body
     * @param {number} openingId
     * @param {number} applicationId
     * @param {Array<any>} [files]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    EmailApi.prototype.emailSend = function (subject, body, openingId, applicationId, files, xTenantID, options) {
        var _this = this;
        return exports.EmailApiFp(this.configuration).emailSend(subject, body, openingId, applicationId, files, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmailApi;
}(base_1.BaseAPI));
exports.EmailApi = EmailApi;
/**
 * EmailTemplateApi - axios parameter creator
 * @export
 */
exports.EmailTemplateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} templateType
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateGetByType: function (templateType, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateType' is not null or undefined
                            common_1.assertParamExists('emailTemplateGetByType', 'templateType', templateType);
                            localVarPath = "/EmailTemplate/{templateType}"
                                .replace("{" + "templateType" + "}", encodeURIComponent(String(templateType)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EmailTemplateApi - functional programming interface
 * @export
 */
exports.EmailTemplateApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.EmailTemplateApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} templateType
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateGetByType: function (templateType, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.emailTemplateGetByType(templateType, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * EmailTemplateApi - factory interface
 * @export
 */
exports.EmailTemplateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.EmailTemplateApiFp(configuration);
    return {
        /**
         *
         * @param {string} templateType
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateGetByType: function (templateType, xTenantID, options) {
            return localVarFp.emailTemplateGetByType(templateType, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EmailTemplateApi - object-oriented interface
 * @export
 * @class EmailTemplateApi
 * @extends {BaseAPI}
 */
var EmailTemplateApi = /** @class */ (function (_super) {
    __extends(EmailTemplateApi, _super);
    function EmailTemplateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} templateType
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    EmailTemplateApi.prototype.emailTemplateGetByType = function (templateType, xTenantID, options) {
        var _this = this;
        return exports.EmailTemplateApiFp(this.configuration).emailTemplateGetByType(templateType, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmailTemplateApi;
}(base_1.BaseAPI));
exports.EmailTemplateApi = EmailTemplateApi;
/**
 * JobActivityApi - axios parameter creator
 * @export
 */
exports.JobActivityApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {CreateJobActivityComment} [createJobActivityComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentAdd: function (openingId, applicationId, activityId, createJobActivityComment, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentAdd', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentAdd', 'applicationId', applicationId);
                            // verify required parameter 'activityId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentAdd', 'activityId', activityId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity/{activityId}/Comment"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "activityId" + "}", encodeURIComponent(String(activityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobActivityComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentDelete: function (openingId, applicationId, activityId, commentId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentDelete', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentDelete', 'applicationId', applicationId);
                            // verify required parameter 'activityId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentDelete', 'activityId', activityId);
                            // verify required parameter 'commentId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentDelete', 'commentId', commentId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity/{activityId}/Comment/{commentId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "activityId" + "}", encodeURIComponent(String(activityId)))
                                .replace("{" + "commentId" + "}", encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {number} commentId
         * @param {CreateJobActivityComment} [createJobActivityComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentUpdate: function (openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentUpdate', 'applicationId', applicationId);
                            // verify required parameter 'activityId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentUpdate', 'activityId', activityId);
                            // verify required parameter 'commentId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentUpdate', 'commentId', commentId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity/{activityId}/Comment/{commentId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "activityId" + "}", encodeURIComponent(String(activityId)))
                                .replace("{" + "commentId" + "}", encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobActivityComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentsGet: function (openingId, applicationId, activityId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentsGet', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentsGet', 'applicationId', applicationId);
                            // verify required parameter 'activityId' is not null or undefined
                            common_1.assertParamExists('jobActivityCommentsGet', 'activityId', activityId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity/{activityId}/Comment"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "activityId" + "}", encodeURIComponent(String(activityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobActivity} [createJobActivity]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCreate: function (openingId, applicationId, createJobActivity, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityCreate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityCreate', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobActivity, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {boolean} [withComments]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityGetByApplicationId: function (openingId, applicationId, withComments, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityGetByApplicationId', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityGetByApplicationId', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (withComments !== undefined) {
                                localVarQueryParameter['withComments'] = withComments;
                            }
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {CreateJobActivity} [createJobActivity]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityUpdate: function (openingId, applicationId, activityId, createJobActivity, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobActivityUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobActivityUpdate', 'applicationId', applicationId);
                            // verify required parameter 'activityId' is not null or undefined
                            common_1.assertParamExists('jobActivityUpdate', 'activityId', activityId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Activity/{activityId}/update"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "activityId" + "}", encodeURIComponent(String(activityId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobActivity, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobActivityApi - functional programming interface
 * @export
 */
exports.JobActivityApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobActivityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {CreateJobActivityComment} [createJobActivityComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentAdd: function (openingId, applicationId, activityId, createJobActivityComment, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityCommentAdd(openingId, applicationId, activityId, createJobActivityComment, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentDelete: function (openingId, applicationId, activityId, commentId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityCommentDelete(openingId, applicationId, activityId, commentId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {number} commentId
         * @param {CreateJobActivityComment} [createJobActivityComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentUpdate: function (openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityCommentUpdate(openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentsGet: function (openingId, applicationId, activityId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityCommentsGet(openingId, applicationId, activityId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobActivity} [createJobActivity]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCreate: function (openingId, applicationId, createJobActivity, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityCreate(openingId, applicationId, createJobActivity, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {boolean} [withComments]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityGetByApplicationId: function (openingId, applicationId, withComments, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityGetByApplicationId(openingId, applicationId, withComments, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {CreateJobActivity} [createJobActivity]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityUpdate: function (openingId, applicationId, activityId, createJobActivity, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobActivityUpdate(openingId, applicationId, activityId, createJobActivity, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobActivityApi - factory interface
 * @export
 */
exports.JobActivityApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobActivityApiFp(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {CreateJobActivityComment} [createJobActivityComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentAdd: function (openingId, applicationId, activityId, createJobActivityComment, xTenantID, options) {
            return localVarFp.jobActivityCommentAdd(openingId, applicationId, activityId, createJobActivityComment, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentDelete: function (openingId, applicationId, activityId, commentId, xTenantID, options) {
            return localVarFp.jobActivityCommentDelete(openingId, applicationId, activityId, commentId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {number} commentId
         * @param {CreateJobActivityComment} [createJobActivityComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentUpdate: function (openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options) {
            return localVarFp.jobActivityCommentUpdate(openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCommentsGet: function (openingId, applicationId, activityId, xTenantID, options) {
            return localVarFp.jobActivityCommentsGet(openingId, applicationId, activityId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobActivity} [createJobActivity]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityCreate: function (openingId, applicationId, createJobActivity, xTenantID, options) {
            return localVarFp.jobActivityCreate(openingId, applicationId, createJobActivity, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {boolean} [withComments]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityGetByApplicationId: function (openingId, applicationId, withComments, xTenantID, options) {
            return localVarFp.jobActivityGetByApplicationId(openingId, applicationId, withComments, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} activityId
         * @param {CreateJobActivity} [createJobActivity]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobActivityUpdate: function (openingId, applicationId, activityId, createJobActivity, xTenantID, options) {
            return localVarFp.jobActivityUpdate(openingId, applicationId, activityId, createJobActivity, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobActivityApi - object-oriented interface
 * @export
 * @class JobActivityApi
 * @extends {BaseAPI}
 */
var JobActivityApi = /** @class */ (function (_super) {
    __extends(JobActivityApi, _super);
    function JobActivityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} activityId
     * @param {CreateJobActivityComment} [createJobActivityComment]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityCommentAdd = function (openingId, applicationId, activityId, createJobActivityComment, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityCommentAdd(openingId, applicationId, activityId, createJobActivityComment, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} activityId
     * @param {number} commentId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityCommentDelete = function (openingId, applicationId, activityId, commentId, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityCommentDelete(openingId, applicationId, activityId, commentId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} activityId
     * @param {number} commentId
     * @param {CreateJobActivityComment} [createJobActivityComment]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityCommentUpdate = function (openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityCommentUpdate(openingId, applicationId, activityId, commentId, createJobActivityComment, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} activityId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityCommentsGet = function (openingId, applicationId, activityId, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityCommentsGet(openingId, applicationId, activityId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {CreateJobActivity} [createJobActivity]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityCreate = function (openingId, applicationId, createJobActivity, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityCreate(openingId, applicationId, createJobActivity, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {boolean} [withComments]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityGetByApplicationId = function (openingId, applicationId, withComments, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityGetByApplicationId(openingId, applicationId, withComments, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} activityId
     * @param {CreateJobActivity} [createJobActivity]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobActivityApi
     */
    JobActivityApi.prototype.jobActivityUpdate = function (openingId, applicationId, activityId, createJobActivity, xTenantID, options) {
        var _this = this;
        return exports.JobActivityApiFp(this.configuration).jobActivityUpdate(openingId, applicationId, activityId, createJobActivity, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobActivityApi;
}(base_1.BaseAPI));
exports.JobActivityApi = JobActivityApi;
/**
 * JobApplicationApi - axios parameter creator
 * @export
 */
exports.JobApplicationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {boolean} candidatePoolConsent
         * @param {number} openingId
         * @param {string} [submissionId]
         * @param {string} [applicationType]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAdd: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'firstName' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'firstName', firstName);
                            // verify required parameter 'lastName' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'lastName', lastName);
                            // verify required parameter 'email' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'email', email);
                            // verify required parameter 'phoneNumber' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'phoneNumber', phoneNumber);
                            // verify required parameter 'workExperience' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'workExperience', workExperience);
                            // verify required parameter 'educationGrade' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'educationGrade', educationGrade);
                            // verify required parameter 'education' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'education', education);
                            // verify required parameter 'candidatePoolConsent' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'candidatePoolConsent', candidatePoolConsent);
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationAdd', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            if (firstName !== undefined) {
                                localVarFormParams.append('FirstName', firstName);
                            }
                            if (lastName !== undefined) {
                                localVarFormParams.append('LastName', lastName);
                            }
                            if (email !== undefined) {
                                localVarFormParams.append('Email', email);
                            }
                            if (phoneNumber !== undefined) {
                                localVarFormParams.append('PhoneNumber', phoneNumber);
                            }
                            if (workExperience !== undefined) {
                                localVarFormParams.append('WorkExperience', workExperience);
                            }
                            if (educationGrade !== undefined) {
                                localVarFormParams.append('EducationGrade', educationGrade);
                            }
                            if (education !== undefined) {
                                localVarFormParams.append('Education', education);
                            }
                            if (candidatePoolConsent !== undefined) {
                                localVarFormParams.append('CandidatePoolConsent', candidatePoolConsent);
                            }
                            if (submissionId !== undefined) {
                                localVarFormParams.append('SubmissionId', submissionId);
                            }
                            if (applicationType !== undefined) {
                                localVarFormParams.append('ApplicationType', applicationType);
                            }
                            if (files) {
                                files.forEach(function (element) {
                                    localVarFormParams.append('files', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAuditCSVGet: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationAuditCSVGet', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationAuditCSVGet', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Audit/CSV"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {LazyLoadJobApplicationAudit} [lazyLoadJobApplicationAudit]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAuditGet: function (openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationAuditGet', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationAuditGet', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Audit"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(lazyLoadJobApplicationAudit, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationDelete: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationDelete', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationDelete', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationDownloadCsvById: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationDownloadCsvById', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationDownloadCsvById', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/csv"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ValidateJobApplicationForm} [validateJobApplicationForm]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationFormValidate: function (validateJobApplicationForm, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/JobOpening/JobApplication/Validate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(validateJobApplicationForm, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationGetById: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationGetById', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationGetById', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationGetByOpeningId: function (openingId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationGetByOpeningId', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewGet: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewGet', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewGet', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Interview"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} location
         * @param {string} date
         * @param {boolean} eMailInvitation
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [subject]
         * @param {string} [body]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewInvite: function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'location' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewInvite', 'location', location);
                            // verify required parameter 'date' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewInvite', 'date', date);
                            // verify required parameter 'eMailInvitation' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewInvite', 'eMailInvitation', eMailInvitation);
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewInvite', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewInvite', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Interview"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            if (location !== undefined) {
                                localVarFormParams.append('Location', location);
                            }
                            if (date !== undefined) {
                                localVarFormParams.append('Date', date);
                            }
                            if (eMailInvitation !== undefined) {
                                localVarFormParams.append('EMailInvitation', eMailInvitation);
                            }
                            if (subject !== undefined) {
                                localVarFormParams.append('Subject', subject);
                            }
                            if (body !== undefined) {
                                localVarFormParams.append('Body', body);
                            }
                            if (files) {
                                files.forEach(function (element) {
                                    localVarFormParams.append('files', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} location
         * @param {string} date
         * @param {boolean} eMailInvitation
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [subject]
         * @param {string} [body]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewUpdate: function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'location' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewUpdate', 'location', location);
                            // verify required parameter 'date' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewUpdate', 'date', date);
                            // verify required parameter 'eMailInvitation' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewUpdate', 'eMailInvitation', eMailInvitation);
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationInterviewUpdate', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Interview"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            if (location !== undefined) {
                                localVarFormParams.append('Location', location);
                            }
                            if (date !== undefined) {
                                localVarFormParams.append('Date', date);
                            }
                            if (eMailInvitation !== undefined) {
                                localVarFormParams.append('EMailInvitation', eMailInvitation);
                            }
                            if (subject !== undefined) {
                                localVarFormParams.append('Subject', subject);
                            }
                            if (body !== undefined) {
                                localVarFormParams.append('Body', body);
                            }
                            if (files) {
                                files.forEach(function (element) {
                                    localVarFormParams.append('files', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {LazyLoadJobApplication} [lazyLoadJobApplication]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationSearch: function (openingId, lazyLoadJobApplication, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationSearch', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/Search"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(lazyLoadJobApplication, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {UpdateJobApplicationStatus} [updateJobApplicationStatus]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationStatusUpdate: function (openingId, applicationId, updateJobApplicationStatus, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationStatusUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationStatusUpdate', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/status"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateJobApplicationStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplication} [createJobApplication]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationUpdate: function (openingId, applicationId, createJobApplication, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationUpdate', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Update"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobApplication, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplicationVote} [createJobApplicationVote]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationVoteAddOrUpdate: function (openingId, applicationId, createJobApplicationVote, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationVoteAddOrUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationVoteAddOrUpdate', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Vote"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobApplicationVote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} voteId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationVoteDelete: function (openingId, applicationId, voteId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationVoteDelete', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationVoteDelete', 'applicationId', applicationId);
                            // verify required parameter 'voteId' is not null or undefined
                            common_1.assertParamExists('jobApplicationVoteDelete', 'voteId', voteId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Vote/{voteId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "voteId" + "}", encodeURIComponent(String(voteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationApi - functional programming interface
 * @export
 */
exports.JobApplicationApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobApplicationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {boolean} candidatePoolConsent
         * @param {number} openingId
         * @param {string} [submissionId]
         * @param {string} [applicationType]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAdd: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationAdd(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAuditCSVGet: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationAuditCSVGet(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {LazyLoadJobApplicationAudit} [lazyLoadJobApplicationAudit]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAuditGet: function (openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationAuditGet(openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationDelete: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationDelete(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationDownloadCsvById: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationDownloadCsvById(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ValidateJobApplicationForm} [validateJobApplicationForm]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationFormValidate: function (validateJobApplicationForm, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationFormValidate(validateJobApplicationForm, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationGetById: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationGetById(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationGetByOpeningId: function (openingId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationGetByOpeningId(openingId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewGet: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationInterviewGet(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} location
         * @param {string} date
         * @param {boolean} eMailInvitation
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [subject]
         * @param {string} [body]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewInvite: function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationInterviewInvite(location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} location
         * @param {string} date
         * @param {boolean} eMailInvitation
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [subject]
         * @param {string} [body]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewUpdate: function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationInterviewUpdate(location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {LazyLoadJobApplication} [lazyLoadJobApplication]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationSearch: function (openingId, lazyLoadJobApplication, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationSearch(openingId, lazyLoadJobApplication, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {UpdateJobApplicationStatus} [updateJobApplicationStatus]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationStatusUpdate: function (openingId, applicationId, updateJobApplicationStatus, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationStatusUpdate(openingId, applicationId, updateJobApplicationStatus, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplication} [createJobApplication]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationUpdate: function (openingId, applicationId, createJobApplication, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationUpdate(openingId, applicationId, createJobApplication, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplicationVote} [createJobApplicationVote]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationVoteAddOrUpdate: function (openingId, applicationId, createJobApplicationVote, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationVoteAddOrUpdate(openingId, applicationId, createJobApplicationVote, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} voteId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationVoteDelete: function (openingId, applicationId, voteId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationVoteDelete(openingId, applicationId, voteId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationApi - factory interface
 * @export
 */
exports.JobApplicationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobApplicationApiFp(configuration);
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {boolean} candidatePoolConsent
         * @param {number} openingId
         * @param {string} [submissionId]
         * @param {string} [applicationType]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAdd: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options) {
            return localVarFp.jobApplicationAdd(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAuditCSVGet: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.jobApplicationAuditCSVGet(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {LazyLoadJobApplicationAudit} [lazyLoadJobApplicationAudit]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationAuditGet: function (openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options) {
            return localVarFp.jobApplicationAuditGet(openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationDelete: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.jobApplicationDelete(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationDownloadCsvById: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.jobApplicationDownloadCsvById(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ValidateJobApplicationForm} [validateJobApplicationForm]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationFormValidate: function (validateJobApplicationForm, xTenantID, options) {
            return localVarFp.jobApplicationFormValidate(validateJobApplicationForm, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationGetById: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.jobApplicationGetById(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationGetByOpeningId: function (openingId, xTenantID, options) {
            return localVarFp.jobApplicationGetByOpeningId(openingId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewGet: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.jobApplicationInterviewGet(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} location
         * @param {string} date
         * @param {boolean} eMailInvitation
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [subject]
         * @param {string} [body]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewInvite: function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
            return localVarFp.jobApplicationInterviewInvite(location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} location
         * @param {string} date
         * @param {boolean} eMailInvitation
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [subject]
         * @param {string} [body]
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationInterviewUpdate: function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
            return localVarFp.jobApplicationInterviewUpdate(location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {LazyLoadJobApplication} [lazyLoadJobApplication]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationSearch: function (openingId, lazyLoadJobApplication, xTenantID, options) {
            return localVarFp.jobApplicationSearch(openingId, lazyLoadJobApplication, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {UpdateJobApplicationStatus} [updateJobApplicationStatus]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationStatusUpdate: function (openingId, applicationId, updateJobApplicationStatus, xTenantID, options) {
            return localVarFp.jobApplicationStatusUpdate(openingId, applicationId, updateJobApplicationStatus, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplication} [createJobApplication]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationUpdate: function (openingId, applicationId, createJobApplication, xTenantID, options) {
            return localVarFp.jobApplicationUpdate(openingId, applicationId, createJobApplication, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplicationVote} [createJobApplicationVote]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationVoteAddOrUpdate: function (openingId, applicationId, createJobApplicationVote, xTenantID, options) {
            return localVarFp.jobApplicationVoteAddOrUpdate(openingId, applicationId, createJobApplicationVote, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} voteId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationVoteDelete: function (openingId, applicationId, voteId, xTenantID, options) {
            return localVarFp.jobApplicationVoteDelete(openingId, applicationId, voteId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobApplicationApi - object-oriented interface
 * @export
 * @class JobApplicationApi
 * @extends {BaseAPI}
 */
var JobApplicationApi = /** @class */ (function (_super) {
    __extends(JobApplicationApi, _super);
    function JobApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} email
     * @param {string} phoneNumber
     * @param {string} workExperience
     * @param {string} educationGrade
     * @param {string} education
     * @param {boolean} candidatePoolConsent
     * @param {number} openingId
     * @param {string} [submissionId]
     * @param {string} [applicationType]
     * @param {Array<any>} [files]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationAdd = function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationAdd(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, openingId, submissionId, applicationType, files, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationAuditCSVGet = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationAuditCSVGet(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {LazyLoadJobApplicationAudit} [lazyLoadJobApplicationAudit]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationAuditGet = function (openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationAuditGet(openingId, applicationId, lazyLoadJobApplicationAudit, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationDelete = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationDelete(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationDownloadCsvById = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationDownloadCsvById(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ValidateJobApplicationForm} [validateJobApplicationForm]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationFormValidate = function (validateJobApplicationForm, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationFormValidate(validateJobApplicationForm, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationGetById = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationGetById(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationGetByOpeningId = function (openingId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationGetByOpeningId(openingId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationInterviewGet = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationInterviewGet(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} location
     * @param {string} date
     * @param {boolean} eMailInvitation
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [subject]
     * @param {string} [body]
     * @param {Array<any>} [files]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationInterviewInvite = function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationInterviewInvite(location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} location
     * @param {string} date
     * @param {boolean} eMailInvitation
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [subject]
     * @param {string} [body]
     * @param {Array<any>} [files]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationInterviewUpdate = function (location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationInterviewUpdate(location, date, eMailInvitation, openingId, applicationId, subject, body, files, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {LazyLoadJobApplication} [lazyLoadJobApplication]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationSearch = function (openingId, lazyLoadJobApplication, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationSearch(openingId, lazyLoadJobApplication, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {UpdateJobApplicationStatus} [updateJobApplicationStatus]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationStatusUpdate = function (openingId, applicationId, updateJobApplicationStatus, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationStatusUpdate(openingId, applicationId, updateJobApplicationStatus, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {CreateJobApplication} [createJobApplication]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationUpdate = function (openingId, applicationId, createJobApplication, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationUpdate(openingId, applicationId, createJobApplication, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {CreateJobApplicationVote} [createJobApplicationVote]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationVoteAddOrUpdate = function (openingId, applicationId, createJobApplicationVote, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationVoteAddOrUpdate(openingId, applicationId, createJobApplicationVote, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} voteId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationApi
     */
    JobApplicationApi.prototype.jobApplicationVoteDelete = function (openingId, applicationId, voteId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationApiFp(this.configuration).jobApplicationVoteDelete(openingId, applicationId, voteId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobApplicationApi;
}(base_1.BaseAPI));
exports.JobApplicationApi = JobApplicationApi;
/**
 * JobApplicationCommentApi - axios parameter creator
 * @export
 */
exports.JobApplicationCommentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplicationComment} [createJobApplicationComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentAdd: function (openingId, applicationId, createJobApplicationComment, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentAdd', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentAdd', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Comment"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobApplicationComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentDelete: function (openingId, applicationId, commentId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentDelete', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentDelete', 'applicationId', applicationId);
                            // verify required parameter 'commentId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentDelete', 'commentId', commentId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Comment/{commentId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "commentId" + "}", encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentGetByApplicationId', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentGetByApplicationId', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Comment"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {CreateJobApplicationComment} [createJobApplicationComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentUpdate: function (openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentUpdate', 'applicationId', applicationId);
                            // verify required parameter 'commentId' is not null or undefined
                            common_1.assertParamExists('jobApplicationCommentUpdate', 'commentId', commentId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/Comment/{commentId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "commentId" + "}", encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobApplicationComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationCommentApi - functional programming interface
 * @export
 */
exports.JobApplicationCommentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobApplicationCommentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplicationComment} [createJobApplicationComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentAdd: function (openingId, applicationId, createJobApplicationComment, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationCommentAdd(openingId, applicationId, createJobApplicationComment, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentDelete: function (openingId, applicationId, commentId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationCommentDelete(openingId, applicationId, commentId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationCommentGetByApplicationId(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {CreateJobApplicationComment} [createJobApplicationComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentUpdate: function (openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobApplicationCommentUpdate(openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationCommentApi - factory interface
 * @export
 */
exports.JobApplicationCommentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobApplicationCommentApiFp(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateJobApplicationComment} [createJobApplicationComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentAdd: function (openingId, applicationId, createJobApplicationComment, xTenantID, options) {
            return localVarFp.jobApplicationCommentAdd(openingId, applicationId, createJobApplicationComment, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentDelete: function (openingId, applicationId, commentId, xTenantID, options) {
            return localVarFp.jobApplicationCommentDelete(openingId, applicationId, commentId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.jobApplicationCommentGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {CreateJobApplicationComment} [createJobApplicationComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApplicationCommentUpdate: function (openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options) {
            return localVarFp.jobApplicationCommentUpdate(openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobApplicationCommentApi - object-oriented interface
 * @export
 * @class JobApplicationCommentApi
 * @extends {BaseAPI}
 */
var JobApplicationCommentApi = /** @class */ (function (_super) {
    __extends(JobApplicationCommentApi, _super);
    function JobApplicationCommentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {CreateJobApplicationComment} [createJobApplicationComment]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationCommentApi
     */
    JobApplicationCommentApi.prototype.jobApplicationCommentAdd = function (openingId, applicationId, createJobApplicationComment, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationCommentApiFp(this.configuration).jobApplicationCommentAdd(openingId, applicationId, createJobApplicationComment, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} commentId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationCommentApi
     */
    JobApplicationCommentApi.prototype.jobApplicationCommentDelete = function (openingId, applicationId, commentId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationCommentApiFp(this.configuration).jobApplicationCommentDelete(openingId, applicationId, commentId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationCommentApi
     */
    JobApplicationCommentApi.prototype.jobApplicationCommentGetByApplicationId = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationCommentApiFp(this.configuration).jobApplicationCommentGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} commentId
     * @param {CreateJobApplicationComment} [createJobApplicationComment]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationCommentApi
     */
    JobApplicationCommentApi.prototype.jobApplicationCommentUpdate = function (openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationCommentApiFp(this.configuration).jobApplicationCommentUpdate(openingId, applicationId, commentId, createJobApplicationComment, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobApplicationCommentApi;
}(base_1.BaseAPI));
exports.JobApplicationCommentApi = JobApplicationCommentApi;
/**
 * JobApplicationFileApi - axios parameter creator
 * @export
 */
exports.JobApplicationFileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} fileId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload: function (openingId, applicationId, fileId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('fileDownload', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('fileDownload', 'applicationId', applicationId);
                            // verify required parameter 'fileId' is not null or undefined
                            common_1.assertParamExists('fileDownload', 'fileId', fileId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/File/{fileId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "fileId" + "}", encodeURIComponent(String(fileId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} userId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetByApplicationAndUserId: function (openingId, applicationId, userId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('fileGetByApplicationAndUserId', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('fileGetByApplicationAndUserId', 'applicationId', applicationId);
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('fileGetByApplicationAndUserId', 'userId', userId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/User/{userId}/File"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('fileGetByApplicationId', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('fileGetByApplicationId', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/File"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} fileId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileSoftDelete: function (openingId, applicationId, fileId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('fileSoftDelete', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('fileSoftDelete', 'applicationId', applicationId);
                            // verify required parameter 'fileId' is not null or undefined
                            common_1.assertParamExists('fileSoftDelete', 'fileId', fileId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/File/{fileId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "fileId" + "}", encodeURIComponent(String(fileId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {any} [file]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload: function (openingId, applicationId, file, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('fileUpload', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('fileUpload', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/File"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationFileApi - functional programming interface
 * @export
 */
exports.JobApplicationFileApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobApplicationFileApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} fileId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload: function (openingId, applicationId, fileId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fileDownload(openingId, applicationId, fileId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} userId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetByApplicationAndUserId: function (openingId, applicationId, userId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fileGetByApplicationAndUserId(openingId, applicationId, userId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fileGetByApplicationId(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} fileId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileSoftDelete: function (openingId, applicationId, fileId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fileSoftDelete(openingId, applicationId, fileId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {any} [file]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload: function (openingId, applicationId, file, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fileUpload(openingId, applicationId, file, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationFileApi - factory interface
 * @export
 */
exports.JobApplicationFileApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobApplicationFileApiFp(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} fileId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload: function (openingId, applicationId, fileId, xTenantID, options) {
            return localVarFp.fileDownload(openingId, applicationId, fileId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} userId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetByApplicationAndUserId: function (openingId, applicationId, userId, xTenantID, options) {
            return localVarFp.fileGetByApplicationAndUserId(openingId, applicationId, userId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.fileGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} fileId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileSoftDelete: function (openingId, applicationId, fileId, xTenantID, options) {
            return localVarFp.fileSoftDelete(openingId, applicationId, fileId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {any} [file]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload: function (openingId, applicationId, file, xTenantID, options) {
            return localVarFp.fileUpload(openingId, applicationId, file, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobApplicationFileApi - object-oriented interface
 * @export
 * @class JobApplicationFileApi
 * @extends {BaseAPI}
 */
var JobApplicationFileApi = /** @class */ (function (_super) {
    __extends(JobApplicationFileApi, _super);
    function JobApplicationFileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} fileId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationFileApi
     */
    JobApplicationFileApi.prototype.fileDownload = function (openingId, applicationId, fileId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationFileApiFp(this.configuration).fileDownload(openingId, applicationId, fileId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} userId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationFileApi
     */
    JobApplicationFileApi.prototype.fileGetByApplicationAndUserId = function (openingId, applicationId, userId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationFileApiFp(this.configuration).fileGetByApplicationAndUserId(openingId, applicationId, userId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationFileApi
     */
    JobApplicationFileApi.prototype.fileGetByApplicationId = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationFileApiFp(this.configuration).fileGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} fileId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationFileApi
     */
    JobApplicationFileApi.prototype.fileSoftDelete = function (openingId, applicationId, fileId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationFileApiFp(this.configuration).fileSoftDelete(openingId, applicationId, fileId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {any} [file]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationFileApi
     */
    JobApplicationFileApi.prototype.fileUpload = function (openingId, applicationId, file, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationFileApiFp(this.configuration).fileUpload(openingId, applicationId, file, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobApplicationFileApi;
}(base_1.BaseAPI));
exports.JobApplicationFileApi = JobApplicationFileApi;
/**
 * JobApplicationKeyCommentApi - axios parameter creator
 * @export
 */
exports.JobApplicationKeyCommentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateKeyComment} [createKeyComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentAdd: function (openingId, applicationId, createKeyComment, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('keyCommentAdd', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('keyCommentAdd', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/KeyComment"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createKeyComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentDelete: function (openingId, applicationId, commentId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('keyCommentDelete', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('keyCommentDelete', 'applicationId', applicationId);
                            // verify required parameter 'commentId' is not null or undefined
                            common_1.assertParamExists('keyCommentDelete', 'commentId', commentId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/KeyComment/{commentId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "commentId" + "}", encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('keyCommentGetByApplicationId', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('keyCommentGetByApplicationId', 'applicationId', applicationId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/KeyComment"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {CreateKeyComment} [createKeyComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentUpdate: function (openingId, applicationId, commentId, createKeyComment, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('keyCommentUpdate', 'openingId', openingId);
                            // verify required parameter 'applicationId' is not null or undefined
                            common_1.assertParamExists('keyCommentUpdate', 'applicationId', applicationId);
                            // verify required parameter 'commentId' is not null or undefined
                            common_1.assertParamExists('keyCommentUpdate', 'commentId', commentId);
                            localVarPath = "/JobOpening/{openingId}/JobApplication/{applicationId}/KeyComment/{commentId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "applicationId" + "}", encodeURIComponent(String(applicationId)))
                                .replace("{" + "commentId" + "}", encodeURIComponent(String(commentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createKeyComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationKeyCommentApi - functional programming interface
 * @export
 */
exports.JobApplicationKeyCommentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobApplicationKeyCommentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateKeyComment} [createKeyComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentAdd: function (openingId, applicationId, createKeyComment, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.keyCommentAdd(openingId, applicationId, createKeyComment, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentDelete: function (openingId, applicationId, commentId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.keyCommentDelete(openingId, applicationId, commentId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.keyCommentGetByApplicationId(openingId, applicationId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {CreateKeyComment} [createKeyComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentUpdate: function (openingId, applicationId, commentId, createKeyComment, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.keyCommentUpdate(openingId, applicationId, commentId, createKeyComment, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobApplicationKeyCommentApi - factory interface
 * @export
 */
exports.JobApplicationKeyCommentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobApplicationKeyCommentApiFp(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {CreateKeyComment} [createKeyComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentAdd: function (openingId, applicationId, createKeyComment, xTenantID, options) {
            return localVarFp.keyCommentAdd(openingId, applicationId, createKeyComment, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentDelete: function (openingId, applicationId, commentId, xTenantID, options) {
            return localVarFp.keyCommentDelete(openingId, applicationId, commentId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentGetByApplicationId: function (openingId, applicationId, xTenantID, options) {
            return localVarFp.keyCommentGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} applicationId
         * @param {number} commentId
         * @param {CreateKeyComment} [createKeyComment]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keyCommentUpdate: function (openingId, applicationId, commentId, createKeyComment, xTenantID, options) {
            return localVarFp.keyCommentUpdate(openingId, applicationId, commentId, createKeyComment, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobApplicationKeyCommentApi - object-oriented interface
 * @export
 * @class JobApplicationKeyCommentApi
 * @extends {BaseAPI}
 */
var JobApplicationKeyCommentApi = /** @class */ (function (_super) {
    __extends(JobApplicationKeyCommentApi, _super);
    function JobApplicationKeyCommentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {CreateKeyComment} [createKeyComment]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationKeyCommentApi
     */
    JobApplicationKeyCommentApi.prototype.keyCommentAdd = function (openingId, applicationId, createKeyComment, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationKeyCommentApiFp(this.configuration).keyCommentAdd(openingId, applicationId, createKeyComment, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} commentId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationKeyCommentApi
     */
    JobApplicationKeyCommentApi.prototype.keyCommentDelete = function (openingId, applicationId, commentId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationKeyCommentApiFp(this.configuration).keyCommentDelete(openingId, applicationId, commentId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationKeyCommentApi
     */
    JobApplicationKeyCommentApi.prototype.keyCommentGetByApplicationId = function (openingId, applicationId, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationKeyCommentApiFp(this.configuration).keyCommentGetByApplicationId(openingId, applicationId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} applicationId
     * @param {number} commentId
     * @param {CreateKeyComment} [createKeyComment]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApplicationKeyCommentApi
     */
    JobApplicationKeyCommentApi.prototype.keyCommentUpdate = function (openingId, applicationId, commentId, createKeyComment, xTenantID, options) {
        var _this = this;
        return exports.JobApplicationKeyCommentApiFp(this.configuration).keyCommentUpdate(openingId, applicationId, commentId, createKeyComment, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobApplicationKeyCommentApi;
}(base_1.BaseAPI));
exports.JobApplicationKeyCommentApi = JobApplicationKeyCommentApi;
/**
 * JobOpeningApi - axios parameter creator
 * @export
 */
exports.JobOpeningApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} openingId
         * @param {CreateJobOpeningRole} [createJobOpeningRole]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningAddUser: function (openingId, createJobOpeningRole, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningAddUser', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/User"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobOpeningRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningArchive: function (openingId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningArchive', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/Archive"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningClose: function (openingId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningClose', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/Close"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateJobOpening} createJobOpening
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningCreate: function (createJobOpening, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createJobOpening' is not null or undefined
                            common_1.assertParamExists('jobOpeningCreate', 'createJobOpening', createJobOpening);
                            localVarPath = "/JobOpening";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobOpening, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetAll: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/JobOpening";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetById: function (openingId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningGetById', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} status
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetByStatus: function (status, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'status' is not null or undefined
                            common_1.assertParamExists('jobOpeningGetByStatus', 'status', status);
                            localVarPath = "/JobOpening/Status/{status}"
                                .replace("{" + "status" + "}", encodeURIComponent(String(status)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetUsers: function (openingId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningGetUsers', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/User"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningPublish: function (openingId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningPublish', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}/Publish"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} userId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningRemoveUser: function (openingId, userId, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningRemoveUser', 'openingId', openingId);
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('jobOpeningRemoveUser', 'userId', userId);
                            localVarPath = "/JobOpening/{openingId}/User/{userId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)))
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {LazyLoadJobOpening} [lazyLoadJobOpening]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSearch: function (lazyLoadJobOpening, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/JobOpening/Search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(lazyLoadJobOpening, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {CreateJobOpening} [createJobOpening]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningUpdate: function (openingId, createJobOpening, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openingId' is not null or undefined
                            common_1.assertParamExists('jobOpeningUpdate', 'openingId', openingId);
                            localVarPath = "/JobOpening/{openingId}"
                                .replace("{" + "openingId" + "}", encodeURIComponent(String(openingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJobOpening, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobOpeningApi - functional programming interface
 * @export
 */
exports.JobOpeningApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobOpeningApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {CreateJobOpeningRole} [createJobOpeningRole]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningAddUser: function (openingId, createJobOpeningRole, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningAddUser(openingId, createJobOpeningRole, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningArchive: function (openingId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningArchive(openingId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningClose: function (openingId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningClose(openingId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateJobOpening} createJobOpening
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningCreate: function (createJobOpening, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningCreate(createJobOpening, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetAll: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningGetAll(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetById: function (openingId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningGetById(openingId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} status
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetByStatus: function (status, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningGetByStatus(status, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetUsers: function (openingId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningGetUsers(openingId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningPublish: function (openingId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningPublish(openingId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} userId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningRemoveUser: function (openingId, userId, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningRemoveUser(openingId, userId, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {LazyLoadJobOpening} [lazyLoadJobOpening]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSearch: function (lazyLoadJobOpening, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningSearch(lazyLoadJobOpening, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} openingId
         * @param {CreateJobOpening} [createJobOpening]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningUpdate: function (openingId, createJobOpening, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningUpdate(openingId, createJobOpening, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobOpeningApi - factory interface
 * @export
 */
exports.JobOpeningApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobOpeningApiFp(configuration);
    return {
        /**
         *
         * @param {number} openingId
         * @param {CreateJobOpeningRole} [createJobOpeningRole]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningAddUser: function (openingId, createJobOpeningRole, xTenantID, options) {
            return localVarFp.jobOpeningAddUser(openingId, createJobOpeningRole, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningArchive: function (openingId, xTenantID, options) {
            return localVarFp.jobOpeningArchive(openingId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningClose: function (openingId, xTenantID, options) {
            return localVarFp.jobOpeningClose(openingId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateJobOpening} createJobOpening
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningCreate: function (createJobOpening, xTenantID, options) {
            return localVarFp.jobOpeningCreate(createJobOpening, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetAll: function (xTenantID, options) {
            return localVarFp.jobOpeningGetAll(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetById: function (openingId, xTenantID, options) {
            return localVarFp.jobOpeningGetById(openingId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} status
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetByStatus: function (status, xTenantID, options) {
            return localVarFp.jobOpeningGetByStatus(status, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningGetUsers: function (openingId, xTenantID, options) {
            return localVarFp.jobOpeningGetUsers(openingId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningPublish: function (openingId, xTenantID, options) {
            return localVarFp.jobOpeningPublish(openingId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {number} userId
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningRemoveUser: function (openingId, userId, xTenantID, options) {
            return localVarFp.jobOpeningRemoveUser(openingId, userId, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LazyLoadJobOpening} [lazyLoadJobOpening]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSearch: function (lazyLoadJobOpening, xTenantID, options) {
            return localVarFp.jobOpeningSearch(lazyLoadJobOpening, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} openingId
         * @param {CreateJobOpening} [createJobOpening]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningUpdate: function (openingId, createJobOpening, xTenantID, options) {
            return localVarFp.jobOpeningUpdate(openingId, createJobOpening, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobOpeningApi - object-oriented interface
 * @export
 * @class JobOpeningApi
 * @extends {BaseAPI}
 */
var JobOpeningApi = /** @class */ (function (_super) {
    __extends(JobOpeningApi, _super);
    function JobOpeningApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} openingId
     * @param {CreateJobOpeningRole} [createJobOpeningRole]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningAddUser = function (openingId, createJobOpeningRole, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningAddUser(openingId, createJobOpeningRole, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningArchive = function (openingId, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningArchive(openingId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningClose = function (openingId, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningClose(openingId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateJobOpening} createJobOpening
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningCreate = function (createJobOpening, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningCreate(createJobOpening, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningGetAll = function (xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningGetAll(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningGetById = function (openingId, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningGetById(openingId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} status
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningGetByStatus = function (status, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningGetByStatus(status, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningGetUsers = function (openingId, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningGetUsers(openingId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningPublish = function (openingId, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningPublish(openingId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {number} userId
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningRemoveUser = function (openingId, userId, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningRemoveUser(openingId, userId, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LazyLoadJobOpening} [lazyLoadJobOpening]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningSearch = function (lazyLoadJobOpening, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningSearch(lazyLoadJobOpening, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} openingId
     * @param {CreateJobOpening} [createJobOpening]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningApi
     */
    JobOpeningApi.prototype.jobOpeningUpdate = function (openingId, createJobOpening, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningApiFp(this.configuration).jobOpeningUpdate(openingId, createJobOpening, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobOpeningApi;
}(base_1.BaseAPI));
exports.JobOpeningApi = JobOpeningApi;
/**
 * JobOpeningSubmissionApi - axios parameter creator
 * @export
 */
exports.JobOpeningSubmissionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {boolean} candidatePoolConsent
         * @param {string} recaptchaEncodedString
         * @param {string} uuid
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSubmissionCreate: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'firstName' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'firstName', firstName);
                    // verify required parameter 'lastName' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'lastName', lastName);
                    // verify required parameter 'email' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'email', email);
                    // verify required parameter 'phoneNumber' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'phoneNumber', phoneNumber);
                    // verify required parameter 'workExperience' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'workExperience', workExperience);
                    // verify required parameter 'educationGrade' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'educationGrade', educationGrade);
                    // verify required parameter 'education' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'education', education);
                    // verify required parameter 'candidatePoolConsent' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'candidatePoolConsent', candidatePoolConsent);
                    // verify required parameter 'recaptchaEncodedString' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'recaptchaEncodedString', recaptchaEncodedString);
                    // verify required parameter 'uuid' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionCreate', 'uuid', uuid);
                    localVarPath = "/JobOpeningSubmission/{uuid}"
                        .replace("{" + "uuid" + "}", encodeURIComponent(String(uuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                    if (xTenantID !== undefined && xTenantID !== null) {
                        localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                    }
                    if (firstName !== undefined) {
                        localVarFormParams.append('FirstName', firstName);
                    }
                    if (lastName !== undefined) {
                        localVarFormParams.append('LastName', lastName);
                    }
                    if (email !== undefined) {
                        localVarFormParams.append('Email', email);
                    }
                    if (phoneNumber !== undefined) {
                        localVarFormParams.append('PhoneNumber', phoneNumber);
                    }
                    if (workExperience !== undefined) {
                        localVarFormParams.append('WorkExperience', workExperience);
                    }
                    if (educationGrade !== undefined) {
                        localVarFormParams.append('EducationGrade', educationGrade);
                    }
                    if (education !== undefined) {
                        localVarFormParams.append('Education', education);
                    }
                    if (candidatePoolConsent !== undefined) {
                        localVarFormParams.append('CandidatePoolConsent', candidatePoolConsent);
                    }
                    if (recaptchaEncodedString !== undefined) {
                        localVarFormParams.append('RecaptchaEncodedString', recaptchaEncodedString);
                    }
                    if (files) {
                        files.forEach(function (element) {
                            localVarFormParams.append('files', element);
                        });
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} uuid
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSubmissionGetByUUID: function (uuid, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'uuid' is not null or undefined
                    common_1.assertParamExists('jobOpeningSubmissionGetByUUID', 'uuid', uuid);
                    localVarPath = "/JobOpeningSubmission/{uuid}"
                        .replace("{" + "uuid" + "}", encodeURIComponent(String(uuid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xTenantID !== undefined && xTenantID !== null) {
                        localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                    }
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * JobOpeningSubmissionApi - functional programming interface
 * @export
 */
exports.JobOpeningSubmissionApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.JobOpeningSubmissionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {boolean} candidatePoolConsent
         * @param {string} recaptchaEncodedString
         * @param {string} uuid
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSubmissionCreate: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningSubmissionCreate(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} uuid
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSubmissionGetByUUID: function (uuid, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.jobOpeningSubmissionGetByUUID(uuid, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * JobOpeningSubmissionApi - factory interface
 * @export
 */
exports.JobOpeningSubmissionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.JobOpeningSubmissionApiFp(configuration);
    return {
        /**
         *
         * @param {string} firstName
         * @param {string} lastName
         * @param {string} email
         * @param {string} phoneNumber
         * @param {string} workExperience
         * @param {string} educationGrade
         * @param {string} education
         * @param {boolean} candidatePoolConsent
         * @param {string} recaptchaEncodedString
         * @param {string} uuid
         * @param {Array<any>} [files]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSubmissionCreate: function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options) {
            return localVarFp.jobOpeningSubmissionCreate(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} uuid
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobOpeningSubmissionGetByUUID: function (uuid, xTenantID, options) {
            return localVarFp.jobOpeningSubmissionGetByUUID(uuid, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobOpeningSubmissionApi - object-oriented interface
 * @export
 * @class JobOpeningSubmissionApi
 * @extends {BaseAPI}
 */
var JobOpeningSubmissionApi = /** @class */ (function (_super) {
    __extends(JobOpeningSubmissionApi, _super);
    function JobOpeningSubmissionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} email
     * @param {string} phoneNumber
     * @param {string} workExperience
     * @param {string} educationGrade
     * @param {string} education
     * @param {boolean} candidatePoolConsent
     * @param {string} recaptchaEncodedString
     * @param {string} uuid
     * @param {Array<any>} [files]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningSubmissionApi
     */
    JobOpeningSubmissionApi.prototype.jobOpeningSubmissionCreate = function (firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningSubmissionApiFp(this.configuration).jobOpeningSubmissionCreate(firstName, lastName, email, phoneNumber, workExperience, educationGrade, education, candidatePoolConsent, recaptchaEncodedString, uuid, files, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} uuid
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobOpeningSubmissionApi
     */
    JobOpeningSubmissionApi.prototype.jobOpeningSubmissionGetByUUID = function (uuid, xTenantID, options) {
        var _this = this;
        return exports.JobOpeningSubmissionApiFp(this.configuration).jobOpeningSubmissionGetByUUID(uuid, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobOpeningSubmissionApi;
}(base_1.BaseAPI));
exports.JobOpeningSubmissionApi = JobOpeningSubmissionApi;
/**
 * OrganizationalUnitApi - axios parameter creator
 * @export
 */
exports.OrganizationalUnitApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationalUnitGetAll: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/OrganizationalUnit";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * OrganizationalUnitApi - functional programming interface
 * @export
 */
exports.OrganizationalUnitApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.OrganizationalUnitApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationalUnitGetAll: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.organizationalUnitGetAll(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * OrganizationalUnitApi - factory interface
 * @export
 */
exports.OrganizationalUnitApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.OrganizationalUnitApiFp(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationalUnitGetAll: function (xTenantID, options) {
            return localVarFp.organizationalUnitGetAll(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * OrganizationalUnitApi - object-oriented interface
 * @export
 * @class OrganizationalUnitApi
 * @extends {BaseAPI}
 */
var OrganizationalUnitApi = /** @class */ (function (_super) {
    __extends(OrganizationalUnitApi, _super);
    function OrganizationalUnitApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationalUnitApi
     */
    OrganizationalUnitApi.prototype.organizationalUnitGetAll = function (xTenantID, options) {
        var _this = this;
        return exports.OrganizationalUnitApiFp(this.configuration).organizationalUnitGetAll(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationalUnitApi;
}(base_1.BaseAPI));
exports.OrganizationalUnitApi = OrganizationalUnitApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
exports.UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [searchQuery]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersFromKeycloak: function (searchQuery, xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/User";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['searchQuery'] = searchQuery;
                            }
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
exports.UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.UserApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [searchQuery]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersFromKeycloak: function (searchQuery, xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUsersFromKeycloak(searchQuery, xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
exports.UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.UserApiFp(configuration);
    return {
        /**
         *
         * @param {string} [searchQuery]
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersFromKeycloak: function (searchQuery, xTenantID, options) {
            return localVarFp.getUsersFromKeycloak(searchQuery, xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [searchQuery]
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getUsersFromKeycloak = function (searchQuery, xTenantID, options) {
        var _this = this;
        return exports.UserApiFp(this.configuration).getUsersFromKeycloak(searchQuery, xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
/**
 * WorkplaceApi - axios parameter creator
 * @export
 */
exports.WorkplaceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workplaceGetAll: function (xTenantID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/Workplace";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth2 required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)];
                        case 1:
                            // authentication oauth2 required
                            // oauth required
                            _a.sent();
                            if (xTenantID !== undefined && xTenantID !== null) {
                                localVarHeaderParameter['X-Tenant-ID'] = String(xTenantID);
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * WorkplaceApi - functional programming interface
 * @export
 */
exports.WorkplaceApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.WorkplaceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workplaceGetAll: function (xTenantID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.workplaceGetAll(xTenantID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * WorkplaceApi - factory interface
 * @export
 */
exports.WorkplaceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.WorkplaceApiFp(configuration);
    return {
        /**
         *
         * @param {string} [xTenantID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workplaceGetAll: function (xTenantID, options) {
            return localVarFp.workplaceGetAll(xTenantID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * WorkplaceApi - object-oriented interface
 * @export
 * @class WorkplaceApi
 * @extends {BaseAPI}
 */
var WorkplaceApi = /** @class */ (function (_super) {
    __extends(WorkplaceApi, _super);
    function WorkplaceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [xTenantID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkplaceApi
     */
    WorkplaceApi.prototype.workplaceGetAll = function (xTenantID, options) {
        var _this = this;
        return exports.WorkplaceApiFp(this.configuration).workplaceGetAll(xTenantID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WorkplaceApi;
}(base_1.BaseAPI));
exports.WorkplaceApi = WorkplaceApi;
